import React, { useEffect } from 'react'
import { graphql } from 'gatsby'
import Seo from '@components/Seo'
import { useStore } from '@Store/'
import { setHeaderColor, setShowHeaderBackground } from '@Store/'
import { colors } from '@styles/vars/colors.style'
import Hero from '@components/_Partner/Hero'
import Information from '@components/_Partner/Information'
import PageFooter from '@components/_AboutUs/PageFooter'
import CaseStudies from '@components/_Partner/CaseStudies'
import Brands from '@components/_Partner/Brands'


const PartnerPage = ({ data }) => {
  const [, dispatch] = useStore()
  const {
    seo,
    slug,
    parentService,
    featuredImage,
    heroTitle,
    mainInformation,
    clients,
    information,
    caseStudies,
    footer
  } = data.contentfulPartnerPage
  const parentSlug = `what-we-do/${parentService.slug}`
  

  useEffect(() => {
    setHeaderColor(dispatch, colors.white, colors.charcoal)
    setShowHeaderBackground(dispatch, true)
  }, [dispatch])

  return (
    <>
      <Seo data={seo} slug={`what-we-do/${parentService.slug}/${slug}`} />
      
      <Hero 
        title={heroTitle}
        image={featuredImage}
      />

      {mainInformation && <Information data={mainInformation} customBackground={colors.white}/>}

      {clients && <Brands images={clients} />}

      {caseStudies && <CaseStudies items={caseStudies}/>}

      {footer && (
        <PageFooter content={footer} customBackground={colors.pastelSky} customText={colors.charcoal} />
      )}
    </>
  )
}

export default PartnerPage

export const pageQuery = graphql`
  query PartnerPage($slug: String!) {
    contentfulPartnerPage(slug: { eq: $slug }) {
        seo {
            ...SEO
        }
        slug
        parentService {
            slug
        }
        featuredImage {
          ...Image
        }
        heroTitle {
          raw
        }
        mainInformation {
          raw
        }
        clients {
          ...Image
        }
        caseStudies {
          slug
          metadata {
            tags {
              name
            }
          }
          mainImage {
            gatsbyImageData(height: 420, width: 420)
            description
          }
          secondaryImage {
            gatsbyImageData(height: 420, width: 420)
            description
          }
          heroText {
            raw
          }
          title
        }
        footer {
          ...PageFooter
        }
    }
  }
`
